import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-bottom">
                <p>
                    Designed with <span className="heart-icon">❤️</span> by the Course Team
                </p>
            </div>
        </footer>
    );
};

export default Footer;